<template>
  <div :class="['modal-backdrop', wrapperClasses]">
    <div class="modal" :style="modalStyling">
      <button v-if="showClose" class="modal-close" :disabled="disableAction" @click="$emit('close')">&times;</button>
      <slot name="header"></slot>

      <slot name="subHeader"></slot>

      <slot name="body"></slot>

      <div v-if="contentAsHtml" class="modal-content-html" v-html="contentAsHtml"></div>

      <slot name="action"></slot>

      <div v-if="multiButtons" class="multi-buttons-container">
        <div v-for="(button, index) in multiButtons" :key="index"  class="action-button-wrapper">
          <div class="button" @click="$emit('action', button)">{{button}}</div>
        </div>
      </div>

      <div v-if="isWarningModal" class="warning-wrapper">
        <div class="action-button button close" @click="$emit('close')">
          {{warningCloseText}}
        </div>
        <div class="action-button button proceed" @click="$emit('proceed')">
          {{warningProceedText}}
        </div>
      </div>

      <slot name="footer"></slot>
    </div>
    <div v-if="showArrow" :class="['arrow', arrowConfig.arrowClasses]" :style="arrowConfig.arrowStyling"></div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',

    props: {
      arrowConfig: Object,
      contentAsHtml: String,
      disableAction: {
        default: false,
        type: Boolean
      },
      isWarningModal: Boolean,
      modalStyling: String,
      multiButtons: Array,
      showArrow: Boolean,
      showClose: Boolean,
      wrapperClasses: [Array, String],
      warningCloseText: {
        type: String,
        default: 'back'
      },
      warningProceedText: {
        type: String,
        default: 'proceed'
      },
    }
  }
</script>
